var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.692 2.9v11.2c0 1.36-.914 2.4-2.11 2.4H2.11C.914 16.5 0 15.46 0 14.1V2.9C0 1.54.914.5 2.11.5h15.472c1.196 0 2.11 1.04 2.11 2.4Zm-17.02-.8 6.752 5.12c.281.24.563.24.844 0L17.02 2.1H2.673Zm15.614 12V3.06l-7.244 5.52c-.352.24-.774.4-1.196.4-.422 0-.844-.16-1.195-.4L1.407 3.06V14.1c0 .48.28.8.703.8h15.472c.352 0 .704-.32.704-.8Z",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;